﻿export default class FaqAccordionHandler {
    constructor() {
        this.faqItemCl = '.faq__question';
        this.faqItemActiveCl = 'open';

        this.setupEventListeners();
        this.toggleAria();
    }

    setupEventListeners = () => {
        let faqItemEls = document.querySelectorAll(this.faqItemCl);

        faqItemEls.forEach(faqItemOpen => faqItemOpen.addEventListener('click', () => faqItemOpen.parentNode.classList.toggle(this.faqItemActiveCl)))
    };

    toggleAria = () => {
        const items = document.querySelectorAll('.faq__question');

        Array.prototype.forEach.call(items, button => {
            button.onclick = () => {
                let expanded = button.getAttribute('aria-expanded') === 'true' || false;
                button.setAttribute("aria-expanded", !expanded);
            }
        });
    }
}